import { useEffect, useState } from "react";
import AdminHeader from "../../component/AdminHeader";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import { toast } from "react-toastify";

const sitemapViewEndpoint = ApiEndpoints.sitemap.view;
const sitemapUpdateEndpoint = ApiEndpoints.sitemap.update;

export default function SitemapEditor() {
  const [content, setContent] = useState("");
  const [errors, setErrors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const pagename = {
    name: "Sitemap Management",
    user: "Admin",
    innerpage: "Sitemap Management",
  };

  const fetchSitemap = async () => {
    try {
      const response = await ApiRequest("GET", sitemapViewEndpoint);
      setContent(response?.sitemap?.content || "");
    } catch (error) {
      console.log(error);
      toast.error("Unable to load sitemap.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSitemap();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors([]);

    if (!content.trim()) {
      setErrors(["Sitemap XML is required."]);
      return;
    }

    try {
      setSaving(true);
      const response = await ApiRequest("POST", sitemapUpdateEndpoint, { content });
      toast.success(response.message);
    } catch (error) {
      const apiErrors = error?.response?.data?.errors || [];
      const apiMessage =
        error?.response?.data?.message ||
        (typeof error?.response?.data === "string" ? error.response.data : "") ||
        (error?.response?.status ? `Request failed with status ${error.response.status}.` : "") ||
        error?.message ||
        "Unable to update sitemap.";
      setErrors(apiErrors);
      toast.error(apiMessage);
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <AdminHeader pagename={pagename} />

      <div className="add-content-page">
        <form onSubmit={handleSubmit}>
          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Sitemap XML<small>*</small></label>
                  </div>
                  <textarea
                    name="content"
                    value={content}
                    onChange={(e) => setContent(e.target.value)}
                    className="form-control"
                    rows="24"
                    disabled={loading || saving}
                    style={{ height: "auto", fontFamily: "monospace", whiteSpace: "pre", overflow: "auto" }}
                  />
                </div>
              </div>

              {errors.length > 0 && (
                <div className="col-lg-12">
                  <div className="alert alert-danger">
                    {errors.map((error) => (
                      <div key={error}>{error}</div>
                    ))}
                  </div>
                </div>
              )}

              <div className="col-lg-12">
                <button className="default-btn" type="submit" disabled={loading || saving}>
                  {saving ? "Saving..." : "Save Sitemap"}<span></span>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}
